import { signal } from "@preact/signals-react"

export const schemaManifestSignal = signal(null)
export const schemaManifestErrorSignal = signal(null)
export const schemaManifestLoadedSignal = signal(false)